import React from 'react';

export default function Mastercard(props) {
  return (
    <svg width={props.width ? props.width : '44'}
         height={props.height ? props.height : '27'}
         viewBox="0 0 44 27" fill="none" xmlns="http://www.w3.org/2000/svg">s
      <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M30.6557 27C38.0255 27 43.9999 20.9558 43.9999 13.5C43.9999 6.04415 38.0255 0 30.6557 0C27.3528 0 24.3301 1.21404 21.9999 3.22509C19.6698 1.21405 16.6471 2.75991e-05 13.3442 2.75991e-05C5.97438 2.75991e-05 0 6.04418 0 13.5C0 20.9558 5.97438 27 13.3442 27C16.6471 27 19.6698 25.786 22 23.7749C24.3301 25.7859 27.3528 27 30.6557 27Z" fill="white"/>
      <path opacity="0.8" fillRule="evenodd" clipRule="evenodd" d="M21.918 23.8472C24.8346 21.3708 26.6888 17.6553 26.6888 13.5017C26.6888 9.34813 24.8346 5.63267 21.918 3.15625C18.9794 5.63267 17.1113 9.34813 17.1113 13.5017C17.1113 17.6553 18.9794 21.3708 21.918 23.8472Z" fill="white"/>
      <g opacity="0.3">
        <mask id="mask0_Mastercard" type="alpha" maskUnits="userSpaceOnUse" x="17" y="0" width="27" height="27">
          <path d="M43.8005 13.5C43.8005 20.8461 37.8699 26.8 30.5559 26.8C23.2419 26.8 17.3113 20.8461 17.3113 13.5C17.3113 6.15383 23.2419 0.2 30.5559 0.2C37.8699 0.2 43.8005 6.15383 43.8005 13.5Z" fill="#C4C4C4" fillOpacity="0.2" stroke="url(#paint0_linear_19082_272164)" strokeWidth="0.4"/>
        </mask>
        <g mask="url(#mask0_Mastercard)">
          <path d="M43.8005 13.5C43.8005 20.8461 37.8699 26.8 30.5559 26.8C23.2419 26.8 17.3113 20.8461 17.3113 13.5C17.3113 6.15383 23.2419 0.2 30.5559 0.2C37.8699 0.2 43.8005 6.15383 43.8005 13.5Z" fill="url(#paint1_linear_19082_272164)" fillOpacity="0.6" stroke="url(#paint2_linear_19082_272164)" strokeWidth="0.4"/>
        </g>
      </g>
      <mask id="mask1_Mastercard" type="alpha" maskUnits="userSpaceOnUse" x="17" y="0" width="27" height="27">
        <path d="M43.8005 13.5C43.8005 20.8461 37.8699 26.8 30.5559 26.8C23.2419 26.8 17.3113 20.8461 17.3113 13.5C17.3113 6.15383 23.2419 0.2 30.5559 0.2C37.8699 0.2 43.8005 6.15383 43.8005 13.5Z" fill="#C4C4C4" fillOpacity="0.2" stroke="url(#paint3_linear_19082_272164)" strokeWidth="0.4"/>
      </mask>
      <g mask="url(#mask1_Mastercard)">
        <g filter="url(#filter0_b_19082_272164)">
          <ellipse cx="30.5559" cy="13.5" rx="13.4446" ry="13.5" fill="white" fillOpacity="0.2"/>
          <path d="M43.8005 13.5C43.8005 20.8461 37.8699 26.8 30.5559 26.8C23.2419 26.8 17.3113 20.8461 17.3113 13.5C17.3113 6.15383 23.2419 0.2 30.5559 0.2C37.8699 0.2 43.8005 6.15383 43.8005 13.5Z" stroke="url(#paint4_linear_19082_272164)" strokeWidth="0.4"/>
        </g>
      </g>
      <g opacity="0.3">
        <mask id="mask2_Mastercard" type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="27" height="27">
          <path d="M26.6891 13.5C26.6891 20.8461 20.7586 26.8 13.4446 26.8C6.13057 26.8 0.2 20.8461 0.2 13.5C0.2 6.15383 6.13057 0.2 13.4446 0.2C20.7586 0.2 26.6891 6.15383 26.6891 13.5Z" fill="#C4C4C4" fillOpacity="0.2" stroke="url(#paint5_linear_19082_272164)" strokeWidth="0.4"/>
        </mask>
        <g mask="url(#mask2_Mastercard)">
          <path d="M26.6891 13.5C26.6891 20.8461 20.7586 26.8 13.4446 26.8C6.13057 26.8 0.2 20.8461 0.2 13.5C0.2 6.15383 6.13057 0.2 13.4446 0.2C20.7586 0.2 26.6891 6.15383 26.6891 13.5Z" fill="url(#paint6_linear_19082_272164)" fillOpacity="0.9" stroke="url(#paint7_linear_19082_272164)" strokeWidth="0.4"/>
        </g>
      </g>
      <defs>
        <filter id="filter0_b_19082_272164" x="6.11133" y="-11" width="48.8887" height="49" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feGaussianBlur in="BackgroundImage" stdDeviation="5.5"/>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_19082_272164"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_19082_272164" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_19082_272164" x1="22.4077" y1="31.6406" x2="40.0584" y2="-2.03493" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint1_linear_19082_272164" x1="40.3338" y1="27" x2="20.0894" y2="-12.5166" gradientUnits="userSpaceOnUse">
          <stop offset="0.159083" stopColor="white"/>
          <stop offset="1" stopColor="#BCBCBC" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint2_linear_19082_272164" x1="44.8153" y1="34.1718" x2="38.7302" y2="12.7646" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint3_linear_19082_272164" x1="22.4077" y1="31.6406" x2="40.0584" y2="-2.03493" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint4_linear_19082_272164" x1="40.837" y1="33.75" x2="34.7476" y2="5.77702" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="0.330961" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint5_linear_19082_272164" x1="5.29635" y1="31.6406" x2="22.9471" y2="-2.03493" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint6_linear_19082_272164" x1="10.5927" y1="28.2656" x2="25.7387" y2="-9.34607" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint7_linear_19082_272164" x1="27.704" y1="34.1718" x2="21.6189" y2="12.7646" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
